const { isUndefined } = require('lodash');

class ProductSaveToListController {
    constructor(settings, breakpointsService) {
        this.settings = settings;
        this.breakpointsService = breakpointsService;
    }

    $onInit() {
        this.showLink = isUndefined(this.showLink) ? false : this.showLink;
        this.showInline = isUndefined(this.showInline) ? this.breakpointsService.isInSmallFormat : this.showInline;
    }
}

ProductSaveToListController.$inject = ['Settings', 'BreakpointsService'];

const productSaveToListComponentDefinition = {
    bindings: {
        product: '<',
        showLink: '<?',
        classModifier: '@?',
        showInline: '<?',
    },
    controller: ProductSaveToListController,
    template: require('./product-save-to-list.component.html').trim(),
};

module.exports = {
    ProductSaveToListController,
    productSaveToListComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/productsavetolist/product-save-to-list.component.js